<template>
  <footer>
    <b-container class="top">
      <b-row>
        <div class="col-12 col-md-8">
          <address class="footer__address">
            <strong>{{ $t("footer.address.name") }}</strong>
            <p>{{ $t("footer.address.type") }}</p>
            <p>153 rue de l'Université, 75007 PARIS, FRANCE</p>
            <p>
              {{ $t("footer.address.orias") }}
              <a href="https://www.orias.fr" target="_blank" rel="noreferrer"
                >www.orias.fr</a
              >
            </p>
            <br />
            <p class="phonenumber">
              {{ $t("footer.address.phone_number") }}
              <a href="tel:+330140479100">+33 (0)1 40 47 91 00</a>
            </p>
            <p>
              {{ $t("footer.address.email") }}
              <a href="mailto:contact@acs-ami.com">contact@acs-ami.com </a>
            </p>
            <p v-html="$t('footer.address.expatriation')"></p>
          </address>
        </div>
        <div class="col-12 col-md-4 d-flex justify-content-end">
          <svg
            class="birds"
            viewBox="0 0 481.33 280.2"
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="100%"
          >
            <path
              d="M105.8,222.12l13.35,1.46,5.42,1.47s6.93-25.17,10.88-24.65,4.91,9.86,4.91,9.86,1,10.34-2.94,17.77l3.93,5.43s15.8-3,18.26,3.45c0,0,2,2-15.8-.49,0,0-8.87,9.87-35.52,2,0,0,9.86-1.47,10.86-3.94S105.8,222.12,105.8,222.12Zm70.1-22.23a35.07,35.07,0,0,0,13.82,22.73s-2.47,4.93-10.88,5.42c0,0,14.33,3.93,26.15,2a29,29,0,0,1,12.36-6l10.37-1-2.49-2.93s-3.43-1-10.34.46a4,4,0,0,1-5.45-1s-.48-6.91,3-8.88c0,0,4-11.84-2.47-22.69,0,0-4,2-13.82,24.18,0,0-7.4-6.41-12.34-6.9Zm116.45-8.37,3.94,1s-2,6.93-2,10.37,13.81-3,15.78-6.41c0,0,11.35.49,15.82-4.43l5.9-1.48,11.36-.52-2.47-2s-1.46-3-8.41-2c0,0-6.39,2.51-8.37,1l6.9-3.45,4,.49s-10.87-4.43-26.65,1.47l-8.89,1-2.45-.5,3.44,3-8.89,1Zm131.24-8.87,7.93,1.45s-3.45,11.86.94,23.69A132.8,132.8,0,0,0,442.83,192s-1.46-4,0-6a7.43,7.43,0,0,1,5.45-2.45s3.93,4.44,6.41,14.82c0,0,5.43,8.87,7.89,1,0,0,4-9.86-.51-18.27l2-3,6.9-.49,3.45,1,4.45-1,2.46-1-4-2-3.93-1-2-.47-4.43.47-4.95,1h-2.93l-2.48-2S454.7,167.34,423.59,182.65ZM387.1,144.16l3.93,2.95,1-1.48,1.48-4.43,6.43-2,4.43.47,3.44-1,3.45-1-4.44-2.94-2.46-1-4,1H394l2.44-5c-17.74-3.94-25.65,5.42-25.65,5.42l-7.89.53-.5,4.43-4.43,2,4.43,1.47C353.54,154,357.47,159.44,358,158s11.33-13.3,11.33-13.3C370.8,147.11,387.1,144.16,387.1,144.16Zm-62.2-44.91L320,97.74c-2.46-2.46-6.41.51-6.41.51-9.87,3.47-11.35.47-11.35.47-.49-9.38,4.44-8.37,4.44-11.83s-8.9-13.33-8.9-13.33l-2.47,2-2.94,3.93s1,8.89-4,9.86-11.83-.48-11.83-.48c-5.44-3-15.31-4-15.31-4l-4.94-2,1,3.45c10.88,5.89,15.31,6.9,15.31,6.9a26.44,26.44,0,0,0,6.91,8.88c-2,1.49-9.38,4-9.38,4l-5.92,3.45h15.3c21.21,1.44,32.57-7.42,32.57-7.42,4.93.5,12.81-1.47,12.81-1.47V99.25ZM236.1,73.08c0-18.74,2.49-11.83,2.49-11.83,4.44,2,15.81.48,15.81.48l-4.94-2.48-2.46-2-4.44.51-8.37-.51s3.93,4-6.42-1.48-31.08,6.9-31.08,6.9l-4,1,.5,2s10.61-1.67,10.35,1.47c-.48,5.93,1.48,25.16,1.48,25.16,9.89-.47,17.76-25.63,17.76-25.63C239.59,79.49,236.1,73.08,236.1,73.08Zm-206,176.54c2.56,3,9.68,6.11,9.68,6.11h4.07l-.51-6.11-2-5.11h8.16L55,244,52,240.44l-3.56-1-3.56,1-7.14-2.55c-2.54-4.6-13.25-1-13.25-1-4.57.52-19.87,10.19-19.87,10.19l-4.58,2,5.61,2v7.64C2.55,272.06,8.17,280.2,8.17,280.2c1.51-4.57,13.74-26.48,13.74-26.48C22.92,248.59,30.07,249.62,30.07,249.62ZM158.46,24.44c-3.56-4.06-10.71-2-10.71-2-6.61.52-9.67-1-9.67-1,4.09-7.12,9.18-8.14,9.18-8.14,1.51-2.56,1-14.25.49-12.74S142.17,0,142.17,0c-12.23,13.26-21.41,19.87-21.41,19.87-9.16-5.58-18.34,0-18.34,0,3.56-.49,22.92,3.07,14.26,5.62S105,31.09,105,31.09c7.15-.51,15.8,2,15.8,2,19.89-.5,25.48-8.15,27-6.1S162,28.53,162,28.53Z"
            />
          </svg>
        </div>
      </b-row>
    </b-container>
    <ul class="links">
      <li>
        <span class="text-up">{{ $t("footer.all_rights_reserved") }}</span>
      </li>
      <li>
        <a
          :href="$t('footer.menu.discover_acs.link')"
          target="_blank"
          rel="noreferrer"
          class="text-up"
        >
          {{ $t("footer.menu.discover_acs.name") }}
        </a>
      </li>
      <li>
        <a
          :href="$t('footer.menu.legal.link')"
          target="_blank"
          rel="noreferrer"
          class="text-up"
        >
          {{ $t("footer.menu.legal.name") }}
        </a>
      </li>
      <li>
        <a
          :href="$t('footer.menu.contact.link')"
          target="_blank"
          rel="noreferrer"
          class="text-up"
        >
          {{ $t("footer.menu.contact.name") }}
        </a>
      </li>
    </ul>
  </footer>
</template>

<style lang="scss" scoped>
footer {
  background: #bde4f3;
  color: #676767;
  font-size: var(--font-sm);

  strong {
    font-weight: 600;
  }
}

.top {
  padding: 20px 0;

  ::v-deep(a) {
    color: #2f738e;
    font-weight: 700;
  }
}

.links {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  background: #154f5f;

  span,
  a {
    display: inline-flex;
    color: #ffffff;
    padding: 10px;
    text-transform: uppercase;
    font-size: var(--font-xxs);
  }
}

.phonenumber {
  a {
    font-weight: 600;
  }
}

.birds {
  width: 200px;
  height: 100px;
  fill: #676767;
}
</style>
